var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c(
        "router-link",
        {
          staticClass: "nav",
          class: { col: _vm.message == "1" },
          attrs: { to: "/PaymentCode" }
        },
        [
          _c("div", { staticClass: "tu" }, [
            _c("i", { staticClass: "iconfont icontiaoma" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "zi" }, [_c("span", [_vm._v("付款码")])])
        ]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "nav",
          class: { col: _vm.message == "2" },
          attrs: { to: "/CardKeyDetails" }
        },
        [
          _c("div", { staticClass: "tu" }, [
            _c("i", { staticClass: "iconfont iconkahao" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "zi" }, [_c("span", [_vm._v("卡号密钥")])])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-81440b78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81440b78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = null
// module chunks = 